import { useEffect, useState } from "react";
import { api, apiError, fmtDateTime } from "../lib/api";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function OutboxPage() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/email-outbox");
                setRows(data);
            } catch (e) { toast.error(apiError(e)); }
            finally { setLoading(false); }
        })();
    }, []);

    return (
        <div className="mx-auto max-w-5xl px-4 sm:px-6 py-6 sm:py-10">
            <div>
                <div className="text-xs font-medium uppercase tracking-wider text-gray-500">HO Admin</div>
                <h1 className="font-display text-2xl sm:text-3xl font-bold text-[#1E3355] mt-1">Email Outbox</h1>
                <p className="text-sm text-gray-500 mt-1">Daily summaries sent to HO. Rows are queued when SMTP is not yet configured.</p>
            </div>
            <div className="mt-6 rounded-xl bg-white border border-gray-100 fx-shadow-card overflow-hidden">
                {loading ? <div className="p-6 text-center text-sm text-gray-500">Loading…</div> :
                rows.length === 0 ? <div className="p-10 text-center text-sm text-gray-500" data-testid="no-outbox">Outbox is empty.</div> :
                <ul className="divide-y divide-gray-100" data-testid="outbox-list">
                    {rows.map((r) => (
                        <li key={r.id} className="p-4 sm:p-5" data-testid={`outbox-${r.id}`}>
                            <div className="flex items-start justify-between gap-3">
                                <div className="flex items-start gap-3 flex-1 min-w-0">
                                    <div className="w-9 h-9 rounded-full bg-[#F4F6F9] text-[#1E3355] flex items-center justify-center flex-shrink-0">
                                        <Mail className="w-4 h-4" />
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <div className="font-display font-semibold text-[#1E3355] text-sm">{r.subject}</div>
                                        <div className="text-xs text-gray-500 mt-0.5">To: {r.to?.length ? r.to.join(", ") : <span className="italic">no recipients configured</span>}</div>
                                        <div className="text-[11px] text-gray-500 mt-1">{fmtDateTime(r.created_at)}</div>
                                    </div>
                                </div>
                                <StatusBadge status={r.status} />
                            </div>
                            <pre className="mt-3 whitespace-pre-wrap text-[11px] bg-[#F4F6F9] border border-gray-100 rounded-md p-3 max-h-40 overflow-auto text-gray-700">{r.body}</pre>
                            {r.error && <div className="mt-2 text-[11px] text-[#E02B2B]">Error: {r.error}</div>}
                        </li>
                    ))}
                </ul>}
            </div>
        </div>
    );
}

function StatusBadge({ status }) {
    const map = {
        sent: "bg-emerald-50 text-emerald-700 border-emerald-200",
        failed: "bg-red-50 text-[#E02B2B] border-red-200",
    };
    const cls = map[status] || "bg-amber-50 text-amber-700 border-amber-200";
    return <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold border ${cls}`}>{status}</span>;
}
